type PersonJson = {
  name?: string;
  function?: string;
  role?: string;
  email?: string;
  phone?: string;
};

export function formatAddress(
  street: string | null | undefined,
  zip: string | null | undefined,
  city: string | null | undefined,
  country?: string | null,
): string | null {
  const locality = [zip, city].filter(Boolean).join(' ');
  const value = [street, locality, country].filter(Boolean).join(', ');
  return value || null;
}

export function formatBoolean(value: boolean | null | undefined): string | null {
  return value == null ? null : value ? 'Ja' : 'Nein';
}

export function formatPeople(raw: unknown): string | null {
  if (!Array.isArray(raw) || raw.length === 0) return null;
  const value = (raw as PersonJson[])
    .map((person) => {
      const personFunction = person?.function ?? person?.role;
      return [person?.name, personFunction && `(${personFunction})`, person?.email, person?.phone]
        .filter(Boolean)
        .join(' · ');
    })
    .filter(Boolean)
    .join(' | ');
  return value || null;
}

export function formatStringList(raw: unknown): string | null {
  if (!Array.isArray(raw) || raw.length === 0) return null;
  const value = raw.filter((item): item is string => typeof item === 'string' && item.length > 0);
  return value.length > 0 ? value.join(', ') : null;
}
